import { render, staticRenderFns } from "./DkkdModal.vue?vue&type=template&id=6e4c5aba&scoped=true"
import script from "./DkkdModal.vue?vue&type=script&lang=js"
export * from "./DkkdModal.vue?vue&type=script&lang=js"
import style0 from "./DkkdModal.vue?vue&type=style&index=0&id=6e4c5aba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c5aba",
  null
  
)

export default component.exports